// HTML escaping + the shared modal/backdrop primitives used across the app.
import { t } from './lang';
export function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
/** The ✕ every card wears in its top-right corner — same glyph as the float windows'.
 *  A function, not a constant: `t()` must run after the language module has settled. */
export function modalCloseBtn() {
    return `
    <button type="button" class="modal__close" aria-label="${t('common.close')}" title="${t('common.close')}">
        <svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>
    </button>`;
}
/** Cards whose ✕ must run their own teardown instead of the generic dismissal. */
const closeHandlers = new WeakMap();
/**
 * What the card's ✕ does, in order: the handler the modal registered
 * (`onModalClose`), else its own Cancel/close control, else the plain dismissal. The
 * indirection is what lets a modal with teardown (a live socket, a poll timer) keep it
 * without every caller wiring the corner button by hand.
 */
function dismiss(modal) {
    const own = closeHandlers.get(modal);
    if (own) {
        own();
        return;
    }
    const btn = modal.querySelector('[data-modal-close], .modal__cancel');
    if (btn) {
        btn.click();
        return;
    }
    closeModal();
}
/** Register the teardown the ✕ should run for this card (see dismiss). */
export function onModalClose(modal, handler) {
    closeHandlers.set(modal, handler);
}
export function openModal(html) {
    let backdrop = document.getElementById('modal-backdrop');
    if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.id = 'modal-backdrop';
        backdrop.className = 'modal-backdrop';
        document.body.appendChild(backdrop);
    }
    backdrop.innerHTML = `<div class="modal">${modalCloseBtn()}${html}</div>`;
    backdrop.classList.remove('hidden');
    const modal = backdrop.querySelector('.modal');
    modal.querySelector('.modal__close').addEventListener('click', () => dismiss(modal));
    // Modals close only via their explicit ✕/Cancel control — a click on the
    // backdrop (outside the modal) must NOT dismiss it, to avoid losing form input.
    return modal;
}
export function closeModal() {
    const backdrop = document.getElementById('modal-backdrop');
    if (backdrop)
        backdrop.classList.add('hidden');
}
export function showModalErr(el, msg) {
    el.textContent = msg;
    el.style.display = 'block';
}
